import { Box, Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { useLoginContext } from '../../../../../contexts/LoginContext';
import { NotificationProfile } from '../../../types';

interface SpecialEventTypeProps {
  included: boolean;
}

const SpecialEventType: React.FC<SpecialEventTypeProps> = ({ included }) => {
  const { user, updateProfile, selectedProfileIndex } = useLoginContext();
  const selectedProfile = user?.extProfiles[selectedProfileIndex ?? 0];

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    selectedProfile: NotificationProfile
  ) => {
    const checked = e.target.checked;
    const name = e.target.name;
    const regionlessEventTypes = selectedProfile.regionlessEventTypes;
    if (!checked) {
      const idx = regionlessEventTypes.indexOf(name);
      if (idx > -1) {
        regionlessEventTypes.splice(idx, 1);
      }
    } else {
      regionlessEventTypes.push(name);
    }
    selectedProfile.regionlessEventTypes = regionlessEventTypes;
    updateProfile(selectedProfile);
  };

  if (!selectedProfile) {
    return null;
  } else {
    return (
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={included}
              name={'Special Alert'}
              onChange={(e) => handleCheckboxChange(e, selectedProfile)}
            />
          }
          label={'Special Alerts'}
        />
      </Box>
    );
  }
};

export default SpecialEventType;
